import {firebaseStorage, storageRef, deleteObject} from "../../firebase/client-app";
import {UPLOADED_IMAGES_PATH} from "../constants/image.constant";

export {
    deleteSingleImageFile,
    deleteSingleImageThumbnailFile,
}

const deleteSingleImageFile = (image) => {
    const fileReference = storageRef(firebaseStorage, UPLOADED_IMAGES_PATH + '/' + image.fileName);
    return deleteObject(fileReference);
}

const deleteSingleImageThumbnailFile = (image) => {
    const fileReference = storageRef(firebaseStorage, UPLOADED_IMAGES_PATH + '/thumb_' + image.fileName);
    return deleteObject(fileReference);
}
